import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import {
  isB2BAccount,
  getLiveEventStatus,
  getTranslatedShippingMethod,
  i18nTranslate,
} from 'src/utils'
import { displayLastNameFirst } from 'src/utils/localeUtils'
import { OrderSummary } from './OrderSummary'
import {
  CLIENT_NAME,
  APPConfig,
  convertToBoolean,
  EVENT_REFUND_POLICY_URL,
} from 'config/appConfig'
import './styles.scss'

class PrintComponent extends React.Component {
  renderAddress = address => {
    const {
      firstName = '',
      lastName = '',
      addressLine1 = '',
      addressLine2 = '',
      city = '',
      state = '',
      county = '',
      province = '',
      country = '',
      zip = '',
    } = address || {}

    const fullName =
      isB2BAccount() === true ? firstName : `${firstName} ${lastName}`
    const addressLine = `${addressLine1} ${addressLine2}`
    const localityData = `${city} ${state}`

    return (
      <Row className="order-summary-shipping-address-detail" noGutters>
        <Row className="order-summary-sa-value w-100 full-name" noGutters>
          {displayLastNameFirst()
            ? `${lastName} ${firstName}`.trim()
            : `${firstName} ${lastName}`.trim()}
        </Row>
        <Row className="order-summary-sa-value w-100 address-line" noGutters>
          {addressLine1}
        </Row>
        {addressLine2 && (
          <Row className="order-summary-sa-value w-100 address-line" noGutters>
            {addressLine2}
          </Row>
        )}
        <Row className="order-summary-sa-value w-100 region-address" noGutters>
          {localityData}
        </Row>
        <Row className="order-summary-sa-value w-100 region-address" noGutters>
          {province} {county}
        </Row>
        <Row className="order-summary-sa-value w-100 region-address" noGutters>
          {country}
        </Row>
        <Row className="order-summary-sa-value w-100 region-address" noGutters>
          {zip}
        </Row>
      </Row>
    )
  }

  renderOrderDetails = () => {
    const orderInfo = this.props?.item?.[0]?.orderInfo || []
    return orderInfo.map(item => {
      const { title = '', value = '', isDefault = false } = item
      return (
        <>
          {isDefault === true && (
            <div key={title} className="d-flex order-detail-title-wrapper">
              <div className="w-100 font-weight-bold">{title}</div>
              <div className="w-100">{value}</div>
            </div>
          )}
        </>
      )
    })
  }
  renderOrderInfo = () => {
    const {
      isDefault: isDefaultShippingAddress = false,
      shippingInfo = {},
      shippingMethod = {},
    } = this.props?.item?.[0]?.shippingAddress || {}
    /**
     * @note
     * IOM-86 - Multiple Credit Card Support for Print Invoice
     * As per BA's Confirmation, Bill To address is removed from Invoice
     */
    // const { isDefault: isDefaultBillingAddress = false, billingInfo = {} } =
    //   this.props?.item?.[0]?.billingAddress || {}
    return (
      <Row noGutters className="border-bottom border-dark w-100 mb-2">
        <Col xs={7} className="pr-2">
          {this.renderOrderDetails()}
        </Col>
        {/* {isDefaultShippingAddress === true && !isEmpty(billingInfo) && (
          <Col xs={4} className="pr-2">
            <span className="font-weight-bold">
              {i18nTranslate('printOrder.billingAddress', 'Bill To')}:
            </span>
            {this.renderAddress(billingInfo)}
          </Col>
        )} */}
        <Col xs={5}>
          <Row>
            <span className="font-weight-bold">
              {i18nTranslate('printOrder.shippingAddress', 'Ship To')}:
            </span>
            {this.renderAddress(shippingInfo)}
          </Row>
          {shippingMethod && (
            <Row>
              <span className="font-weight-bold">
                {i18nTranslate(
                  'orderSummary.shippingMethodTitle',
                  'Shipping Method'
                )}
                :
              </span>
              {getTranslatedShippingMethod(
                shippingMethod?.code,
                false,
                shippingMethod?.name
              )}
            </Row>
          )}
        </Col>
      </Row>
    )
  }
  renderProductInfo = productList => {
    return (
      <Row
        noGutters
        className="order-detail-info bg-transparent w-100">
        {productList?.length > 0 &&
          productList?.map(list => {
            return (
              list.isDefault === true && (
                <div className={`order-detail-${list.key}`}>{list.value}</div>
              )
            )
          })}
      </Row>
    )
  }
  renderProductTitle = list => {
    return (
      list?.isDefault === true && (
        <div
          key={list.key}
          className={`order-detail-${list.key} text-uppercase`}>
          {list.title}
        </div>
      )
    )
  }
  renderItemInfo = () => {
    const orderProductTitle =
      this.props?.item?.[0]?.orderDetails?.orderProductTitle || []
    const productInfo =
      this.props?.item?.[0]?.orderDetails?.orderProductInfo || []
    return (
      <Row noGutters className="">
        <span className="w-100 font-weight-bold item-info-title mb-2">
          {i18nTranslate('printOrder.orderDetails', 'Order Details')}
        </span>
        <Row noGutters className="order-detail-title w-100">
          {orderProductTitle.length > 0 &&
            orderProductTitle.map(this.renderProductTitle)}
        </Row>
        <Row noGutters className="order-detail-wrapper w-100">
          {productInfo.length > 0 && productInfo.map(this.renderProductInfo)}
        </Row>
      </Row>
    )
  }
  render() {
    const { enableGiftReceipt = false, customGiftMessage = '' } =
      this.props.giftMessage || {}
    const enableLiveEvent = convertToBoolean(getLiveEventStatus())
    const disableReturnPolicyInInvoice = convertToBoolean(
      APPConfig.getAppConfig()?.disableReturnPolicyInInvoice
    )

    return (
      <Container className="w-100 h-auto">
        <Row
          noGutters
          className="print-order-wrapper mt-5 border-bottom border-dark justify-content-between mb-2">
          <Col xs={12} className="m-auto">
            <h4 className="text-uppercase mt-3 mb-0">{CLIENT_NAME}</h4>
          </Col>
        </Row>

        {this.renderOrderInfo()}
        {this.renderItemInfo()}
        <OrderSummary {...this.props} />
        {/* <Col
          xs={12}
          className="w-100 order-payment-details text-uppercase mt-2">
          Notes
        </Col> */}
        {enableGiftReceipt && customGiftMessage && (
          <p className="py-1">
            <strong>
              {i18nTranslate('giftMessage', 'Gift Message', {
                nameSpace: 'ssr-resource',
              })}
              :{' '}
            </strong>
            {customGiftMessage}
          </p>
        )}
        {!disableReturnPolicyInInvoice && (
          <>
            <Col
              xs={12}
              className="w-100 return-policy-wrapper text-center mb-2">
              {i18nTranslate('printOrder.returnPolicy', 'Return Policy')}
            </Col>
            {enableLiveEvent ? (
              <p className="w-100 border-bottom border-dark pr-3 pb-2 pr-0 return-policy">
                {i18nTranslate(
                  'event.printReturnPolicy',
                  'If you want to make a return or need a product replacement during L!VE West 2024, please visit the Product Return Counter. For returns after L!VE West 2024, please contact your home market’s help desk. Please check the guidelines here {returnUrl} and then follow the recommended steps.'
                ).replace('{returnUrl}', EVENT_REFUND_POLICY_URL)}
              </p>
            ) : (
              <p className="w-100 border-bottom border-dark pr-3 pb-2 pr-0 return-policy">
                {CLIENT_NAME}{' '}
                {i18nTranslate(
                  'printOrder.returnPolicyDescription',
                  'reserves the right to review each return or exchange on a case-by-case basis.'
                )}
              </p>
            )}
          </>
        )}
        {/*<p className="w-100 border-bottom border-dark">
          <Trans i18nKey="printOrder.dateOfDelivery">
            If there is no other information, the date of invoice is also date
            of delivery
          </Trans>
      </p>*/}
      </Container>
    )
  }
}

export default PrintComponent
export { PrintComponent }
